import { useState, useEffect } from "react";
import { SYSTEM_LISTS_DEFAULTS } from "../lib/globals";
import { loadLocalSystemLists, syncSystemListsFromServer, getSystemLists, saveSystemLists } from "../lib/systemListsStorage";

function useSystemLists() {
  const [lists, setLists] = useState(SYSTEM_LISTS_DEFAULTS);
  useEffect(()=>{
    let active = true;
    loadLocalSystemLists().then((local)=>{ if (active) setLists(local); });
    syncSystemListsFromServer("system-lists-boot").then((next)=>{ if (active) setLists(next); });
    function reload(){ getSystemLists().then((next)=>{ if (active) setLists(next); }); }
    function refreshOnline(){ syncSystemListsFromServer("system-lists-online").then((next)=>{ if (active) setLists(next); }); }
    window.addEventListener("fz:systemlists:updated", reload);
    window.addEventListener("online", refreshOnline);
    return ()=>{
      active = false;
      window.removeEventListener("fz:systemlists:updated", reload);
      window.removeEventListener("online", refreshOnline);
    };
  },[]);
  return [lists, saveSystemLists];
}

export { useSystemLists };
